import { render, staticRenderFns } from "./cart-component.vue?vue&type=template&id=49fc5ff5&lang=html"
import script from "./cart-component.vue?vue&type=script&lang=js"
export * from "./cart-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports